import './index.scss'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  $('.section1>b').css('transform','translateY('+ scroH / 3 +'px)')
});